import React from 'react';

const ChatBubbleLeftRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193l-3.72 3.72a1.125 1.125 0 01-1.59 0l-3.72-3.72A1.125 1.125 0 016 16.897V12.61c0-.97.616-1.813 1.5-2.097m1.5 0A2.25 2.25 0 0113.5 6.75v4.5a2.25 2.25 0 01-3 0v-4.5A2.25 2.25 0 0112 4.5v.75m-8.25 3a2.25 2.25 0 00-1.5 2.097v4.286c0 1.136.847 2.1 1.98 2.193l3.72 3.72a1.125 1.125 0 001.59 0l3.72-3.72A1.125 1.125 0 0018 16.897V12.61c0-.97-.616-1.813-1.5-2.097" />
  </svg>
);

export default ChatBubbleLeftRightIcon;